import styled from 'styled-components';

type SliderItemContainerStyledProps = {
  width: string;
};
export const SliderItemContainerStyled = styled.div<SliderItemContainerStyledProps>`
  flex: ${({ width }): string => `0 0 ${width}`};
  box-sizing: border-box;
`;
